export const ModalFields = {
	TIMER_DATE: 'timer',
	NEXT_STATUS: 'nextState',
	COMMENT: 'statusComment'
};
